import './style.css';
import {
  SoundwaveLoader,
  AudioRecordingLoader,
  BotProcessingLoader,
} from '../Loader';
import { Button, Icon } from '@chatui/core';
import { ChatStatusType } from '../../utils/types';

interface VoiceComposerProps {
  chatStatus: ChatStatusType;
  onStopVoiceMode: () => void;
  onStopRecording: () => void;
}
const VoiceComposer = (props: VoiceComposerProps) => {
  const { chatStatus, onStopRecording, onStopVoiceMode } = props;
  return (
    <div className="voice-composer ChatFooter">
      <div className="Composer">
        {chatStatus === 'processing' && <BotProcessingLoader />}
        <div className="Composer-inputWrap">
          {chatStatus === 'listening' && <AudioRecordingLoader />}
          {chatStatus === 'processing' && (
            <div className="text-center loading-text">Processing...</div>
          )}
          {chatStatus === 'responding' && <SoundwaveLoader />}
        </div>
        <div className="Composer-actions">
          <Button
            variant="text"
            onClick={() => {
              if (chatStatus === 'listening') {
                onStopRecording();
              } else {
                onStopVoiceMode();
              }
            }}
            className="IconBtn"
          >
            <Icon type="close"></Icon>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VoiceComposer;
